/**
 * @fileoverview
 * Utility functions to prevent API response caching
 */

/**
 * Generates a random string to be used as a cache-busting parameter
 */
const generateCacheBuster = (): string => {
  return Date.now().toString()
}

/**
 * Adds cache-busting parameter to the request config to prevent caching.
 * Special no-cache headers are not added because they would cause CDN caching
 * to be bypassed.
 *
 * @param url The original URL
 * @param config Optional existing request config
 * @returns Array containing [modifiedUrl, config] with cache prevention
 */
export const preventCache = (
  url: string,
  config: Record<string, unknown> = {},
): [string, Record<string, unknown>] => {
  const separator = url.includes('?') ? '&' : '?'
  const cacheBuster = generateCacheBuster()
  const modifiedUrl = `${url}${separator}_=${cacheBuster}`

  return [modifiedUrl, config]
}
